module.exports = __webpack_public_path__ + "img/LogoFrontPage.daec513a.png";